export default {
    SET_LANGUAGE_CURRENT: (state, payload) => {
        state.language_current = payload;
    },
    SET_CHECKED: (state, payload) => {
        state.checked = payload;
    },
    SET_USER: (state, payload) => {
        state.user = payload;
    },
    SET_newOrder: (state, payload) => {
        state.newOrder = payload;
    },
    OPEN_MODAL: (state, payload) => {
        state.modalName = payload;
    },
    SET_VALUE: (state, payload) => {
        state.valueSelected = payload;
    },
    SET_LAST_UPDATE: (state, payload) => {
        state.lastUpdate = payload;
    },
    SET_TEXT: (state, payload) => {
        state.text = payload;
    },
    SET_SHOP: (state, payload) => {
        state.shop = payload;
    },
    SET_AUDIO: (state, payload) => {
        state.audio = payload;
    },
    SET_TICKET: (state, payload) => {
        state.ticket = payload;
    },
    SET_FEATURES: (state, payload) => {
        state.features = payload;
    },
    SET_LANGUAGES: (state, payload) => {
        state.languages = payload;
    },
    SET_LOCALIZATIONS: (state, payload) => {
        state.localizations = payload;
    },
    SET_ROOT: (state, payload) => {
        state.root = payload;
    },
    SET_MESSAGE: (state, payload) => {
        state.lastMessage = payload;
    },
    SET_BUSINESS: (state, payload) => {
        state.business = payload;
    },
    SET_LANGUAGE: (state, payload) => {
        state.language = payload;
    },
    SET_LOCATION: (state, payload) => {
        state.location = payload;
    },
    SET_ROLE: (state, payload) => {
        state.roles = payload;
    },
    SET_STATS: (state, payload) => {
        state.stats = payload;
    },
    SET_ROUTES: (state, payload) => {
        state.routes = payload;
    },
    SET_SCHEDULE: (state, payload) => {
        state.schedules = payload;
    },
    SET_POST: (state, payload) => {
        state.post = payload;
    },
    SET_HOST: (state, payload) => {
        state.host = payload;
    }
}